const {
	includesDocumentRootSelector,
	scopeRuleSelectors,
} = require('./island-root-selector');

/** stylis COMMENT element type — skipped by stringify */
const STYLIS_COMMENT = 'comm';

/** @type {boolean} */
let shouldStripFontSize10FromCurrentRule = false;

/**
 * @param {import('stylis').Element} element
 * @returns {boolean}
 */
function isRpUiHistoricalRootFontSizeDeclaration(element) {
	if (element.props !== 'font-size') {
		return false;
	}

	const declarationValue = String(element.value).trim().replace(/;$/, '');

	return declarationValue === '10px' || declarationValue === 'font-size:10px';
}

/**
 * Scopes Emotion selectors to [data-react-island-root], matching postcss-scope-island-root.
 *
 * @param {import('stylis').Element} element
 * @returns {void}
 */
function scopeIslandRootEmotionStylisPlugin(element) {
	if (element.type === 'rule') {
		const originalSelectors = element.props;
		shouldStripFontSize10FromCurrentRule = includesDocumentRootSelector(originalSelectors);
		element.props = scopeRuleSelectors(originalSelectors);

		return;
	}

	if (element.type !== 'decl' || !shouldStripFontSize10FromCurrentRule) {
		return;
	}

	if (isRpUiHistoricalRootFontSizeDeclaration(element)) {
		element.type = STYLIS_COMMENT;
	}
}

module.exports = { scopeIslandRootEmotionStylisPlugin };
